import CreateCustomPOIPackage from './CreateCustomPOIPackage.component';

export default CreateCustomPOIPackage;